import { JsonpClientBackend } from '@angular/common/http';
import { RecursiveTemplateAstVisitor } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { element } from 'protractor';
import { CouponHolder } from '../holders/coupon-holder';
import { CouponBlueprint } from '../models/coupon-blueprint';
import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class CouponsService 
{
  coupons=Array<CouponBlueprint>();
  couponsList=Array<CouponHolder>();

  constructor(
    private localeservice:LocaleService
  ) { }

  public initialize(coupons:any)
  {
    if(coupons !== null && coupons !== undefined)
      this.coupons = <Array<CouponBlueprint>>coupons;

    this.couponsList = this.getCoupons();
  }

  public getCoupons(ordervalue:number = 0)
  {
    var availableCoupons = new Array<CouponHolder>();

    let usedCouponsData = localStorage.getItem(`UsedCoupons`)

    let usedCoupons = Array<{ID:string, Timestamp:number}>();

    if(usedCouponsData)
      usedCoupons = <Array<{ID:string, Timestamp:number}>> JSON.parse(usedCouponsData);

    const dateNow = new Date();

    const timestampNow = dateNow.getTime() / 1000;

    const dateToday = new Date();

    dateToday.setHours(0,0,0,0);

    const timestampToday = dateToday.getTime() / 1000;

    for (let index = 0; index < this.coupons.length; index++) 
    {
      const element = this.coupons[index];

      if(element.Active === true && element.WeekDays[dateNow.getDay()] === true)
      {
        //Get Start Time
        const startTimeString = element.StartTime;

        const startTimeStringSplit = startTimeString.split(':');
        
        const startTime = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate(), Number(startTimeStringSplit[0]), Number(startTimeStringSplit[1]), Number(startTimeStringSplit[2]));

        const startTimestamp = startTime.getTime() / 1000;

        //Get End Time
        const endTimeString = element.EndTime;

        const endTimeStringSplit = endTimeString.split(':');
        
        const endTime = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate(), Number(endTimeStringSplit[0]), Number(endTimeStringSplit[1]), Number(endTimeStringSplit[2]));

        const endTimestamp = endTime.getTime() / 1000;

        var valueString = '';

        if(element.Mode == 0)
          valueString = `-${this.localeservice.getCurrencyString(element.Value)}`;
        else
          valueString = `-${element.Percentage}%`;

        var orderFloor = '';
        
        if(element.FloorValue > 0)
          orderFloor = `${this.localeservice.instantTranslation("Coupons.CouponHolder.OrderFloor")} ${this.localeservice.getCurrencyString(element.FloorValue)}`

        var couponHolder = new CouponHolder(element.Name, '', orderFloor, element.FloorValue, valueString, false, false, false, element);

        let usedCoupon = usedCoupons.find(x => x.ID == element.ID);

        if(usedCoupon && usedCoupon.Timestamp > timestampToday)
        {
          couponHolder.Used = true;

          couponHolder.Detail = this.localeservice.instantTranslation("Coupons.CouponHolder.Used");

          availableCoupons.push(couponHolder);

          continue;
        }

        if(startTimestamp !== endTimestamp)
        {
          if(timestampNow < startTimestamp)
          {
            var detail = '';

            couponHolder.Available = false;

            var remainingSeconds = startTimestamp - timestampNow;

            var minutes = Math.floor(remainingSeconds / 60);
            var hours = Math.floor(minutes / 60);

            if(hours > 0)
            {
              if(hours === 1)
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.AvailableIn")} ${hours} ${this.localeservice.instantTranslation("Coupons.CouponHolder.HourSingle")}`;
              else
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.AvailableIn")} ${hours} ${this.localeservice.instantTranslation("Coupons.CouponHolder.HourPlural")}`;
            }
            else
            {
              if(minutes === 0)
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.AvailableIn")} ${this.localeservice.instantTranslation("Coupons.CouponHolder.LessThan")} ${minutes} ${this.localeservice.instantTranslation("Coupons.CouponHolder.MinuteSingle")}`;
              if(minutes === 1)
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.AvailableIn")} ${minutes} ${this.localeservice.instantTranslation("Coupons.CouponHolder.MinuteSingle")}`;
              else
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.AvailableIn")} ${minutes} ${this.localeservice.instantTranslation("Coupons.CouponHolder.MinutePlural")}`;
            }

            couponHolder.Detail = detail;
          }
          else if(timestampNow < endTimestamp)
          {
            var detail = '';

            couponHolder.Available = true;

            var remainingSeconds = endTimestamp - timestampNow;

            var minutes = Math.floor(remainingSeconds / 60);
            var hours = Math.floor(minutes / 60);

            if(hours > 0)
            {
              if(hours === 1)
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.Available")} (${this.localeservice.instantTranslation("Coupons.CouponHolder.ExpiresIn")} ${hours} ${this.localeservice.instantTranslation("Coupons.CouponHolder.HourSingle")})`;
              else
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.Available")} (${this.localeservice.instantTranslation("Coupons.CouponHolder.ExpiresIn")} ${hours} ${this.localeservice.instantTranslation("Coupons.CouponHolder.HourPlural")})`;
            }
            else
            {
              if(minutes === 0)
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.Available")} (${this.localeservice.instantTranslation("Coupons.CouponHolder.ExpiresIn")} ${this.localeservice.instantTranslation("Coupons.CouponHolder.LessThan")} ${minutes} ${this.localeservice.instantTranslation("Coupons.CouponHolder.MinuteSingle")})`;
              if(minutes === 1)
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.Available")} (${this.localeservice.instantTranslation("Coupons.CouponHolder.ExpiresIn")} ${minutes} ${this.localeservice.instantTranslation("Coupons.CouponHolder.MinuteSingle")})`;
              else
                detail = `${this.localeservice.instantTranslation("Coupons.CouponHolder.Available")} (${this.localeservice.instantTranslation("Coupons.CouponHolder.ExpiresIn")} ${minutes} ${this.localeservice.instantTranslation("Coupons.CouponHolder.MinutePlural")})`;
            }

            couponHolder.Detail = detail;
          }
          else
          {
            couponHolder.Detail = this.localeservice.instantTranslation("Coupons.CouponHolder.Expired");
            couponHolder.Available = false;
          }
        }
        else
        {
          couponHolder.Detail = this.localeservice.instantTranslation("Coupons.CouponHolder.Available");
          couponHolder.Available = true;
        }

        if(ordervalue > 0 && element.FloorValue > ordervalue)
          couponHolder.FloorRejected = true;

        availableCoupons.push(couponHolder);
      }
    }

    return availableCoupons;
  }
}
